import type { ComponentType } from "react";
import {
  ComingSoon,
  NoContextMessage,
  PermissionMessage,
  useOperatingContext,
} from "@granular/fabric3-core";
import type { FabricApp } from "@granular/fabric3-definitions";
import { checkAppPermissions } from "../helpers";

type GuardedAppProps = {
  appInfo: FabricApp;
};

/**
 * Wraps an app with the container-level guards, in priority order:
 *
 * 1. Not routable → ComingSoon (feature-flag gate)
 * 2. requiresContext + no context → NoContextMessage
 * 3. permissionModel + no permission → PermissionMessage
 * 4. → render app
 */
export const GuardedApp: React.FC<GuardedAppProps> = ({ appInfo }) => {
  const { allContexts, userCan } = useOperatingContext();

  if (!appInfo.routable) return <ComingSoon />;

  if (appInfo.requiresContext && !allContexts?.length)
    return <NoContextMessage />;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const App = appInfo.component as ComponentType<any>;

  if (
    appInfo.permissionModel &&
    !checkAppPermissions(appInfo.permissionModel, userCan)
  )
    return <PermissionMessage />;

  return <App />;
};
